import React, { FC } from "react";
import { Modal } from "venice-ui";
import { t } from "../../helpers/userHelper";
import { dictionary } from "../../untils/dictionary";

interface IReactivateSubscriptionModal {
  handleCancel: () => void;
  handleAction: () => void;
  handleConfirm: () => void;
  loader: boolean;
  confirm: boolean;
  isOpen: boolean;
}

export const ReactivateSubscriptionModal: FC<IReactivateSubscriptionModal> = ({
  handleConfirm,
  handleAction,
  handleCancel,
  loader,
  confirm,
  isOpen,
}) => {
  const onClose = () => {
    if (!loader) {
      handleCancel();
    }
  };

  return (
    <Modal
      title={
        confirm
          ? t(dictionary.subcriptionReactivated)
          : t(dictionary.confirmReactivateSubscription)
      }
      labelClose={confirm ? t(dictionary.close) : t(dictionary.cancel)}
      handleClose={confirm ? handleConfirm : onClose}
      handleConfirm={confirm ? undefined : handleAction}
      labelConfirm={confirm ? undefined : t(dictionary.reactivateSubscription)}
      submitLoader={loader}
      isOpen={isOpen}
      exitOnEsc={true}
    >
      {confirm
        ? t(dictionary.alreadyReactivated)
        : t(dictionary.doYouWantReactivateSubscription)}
    </Modal>
  );
};
